"use client";

/**
 * The visibility dropdown of a FAQ picked for a show, add-on or shop item.
 */

import { Bot, Eye, UserCheck, UserX, type LucideIcon } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import {
  FAQ_VISIBILITIES,
  FAQ_VISIBILITY_LABELS,
  type FaqVisibility,
} from "@/lib/constants/faq-visibility";

export const FAQ_VISIBILITY_ICONS: Record<FaqVisibility, LucideIcon> = {
  visible: Eye,
  ai_only: Bot,
  booked_only: UserCheck,
  guest_only: UserX,
};

export function FaqVisibilitySelect({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: FaqVisibility) => void;
}) {
  return (
    <Select value={value} onValueChange={(v) => onChange(v as FaqVisibility)}>
      <SelectTrigger className="w-full">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {FAQ_VISIBILITIES.map((visibility) => {
          const Icon = FAQ_VISIBILITY_ICONS[visibility];
          return (
            <SelectItem key={visibility} value={visibility}>
              <div className="flex items-center gap-2">
                <Icon className="w-4 h-4" />
                {FAQ_VISIBILITY_LABELS[visibility]}
              </div>
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
